// extracted by mini-css-extract-plugin
module.exports = {"menu":"TabMenu_menu__3q_tF","large":"TabMenu_large__3zO9D","thick":"TabMenu_thick__toMl0"};